
import { TranslationRecord } from '../../types';
import { common } from './common';
import { navigation } from './navigation';
import { hero } from './hero';
import { company } from './company';
import { contact } from './contact';
import { about } from './about';
import { suites } from './suites';
import { reviews } from './reviews';
import { footer } from './footer';
import { rentalTerms } from './rentalTerms';
import { gallery } from './gallery';
import { location } from './location';
import { legal } from './legal';
import { privacyPolicy } from './privacyPolicy';
import { cookiePolicy } from './cookiePolicy';
import { cookieConsent } from './cookieConsent';

export const en: TranslationRecord = {
  ...common,
  ...navigation,
  ...hero,
  ...company,
  ...contact,
  ...about,
  ...suites,
  ...reviews,
  ...footer,
  ...rentalTerms,
  ...gallery,
  ...location,
  ...legal,
  ...privacyPolicy,
  ...cookiePolicy,
  ...cookieConsent,
};

// Also export as enTranslations for backwards compatibility
export const enTranslations = en;
